module.exports = __webpack_public_path__ + "img/account.15ad6769.png";